"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const all_1 = require("../all");
exports.default = (0, all_1.createTheme)({
    colors: {
        primary: '#0F0F0F',
        secondary: '#FFFFFF',
        additional: ['#C4C4C4', '#6C6C6C', '#F2F2F2', '#CACACA'],
        gray: '#E0E0E0',
    },
    page: {
        width: '78.625rem',
    },
    global: (0, all_1.css) `
    html {
      font-size: 14px;
    }

    * {
      cursor: none !important;
    }

    :root {
      --nav-height: 8.5625rem;
      @media ${all_1.mobile} {
        --nav-height: 5rem;
      }
    }
  `,
    font: "'neue-montreal', 'Neue Montreal', sans-serif",
    secondaryFont: '"Wulkan Display", Arial',
    radius: {
        small: '0rem',
        big: '0rem',
    },
    modal: {
        css: (0, all_1.css) `
      max-width: 51.875rem;
      width: 100%;
      border-radius: 0;

      > section {
        border: none !important;
      }

      @media ${all_1.mobile} {
        margin-top: 0;
        top: 0;
        min-height: 100vh !important;
        min-height: -webkit-fill-available !important;
        height: 100%;
      }
    `,
    },
    tooltip: {
        css: (0, all_1.css) `
      border-radius: 0;
      background: #000000;
      * {
        color: ${(theme) => theme.colors.secondary} !important;
      }
    `,
        arrow: (0, all_1.css) `
      fill: #000000;
    `,
    },
    buttons: {
        css: (0, all_1.css) `
      font-size: 1rem;
      padding: 0 2rem;
      color: white;
      transition: box-shadow 300ms;
      height: 3.5rem;
      border-radius: 0;
      white-space: nowrap;
      text-transform: uppercase;
    `,
        primaryWithShadow: (0, all_1.css) `
      box-shadow: 0rem 0.625rem 1.8125rem
        ${(theme) => theme.colors.primary.alpha(0.3)};
    `,
        secondary: (0, all_1.css) `
      background: white;
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05);
    `,
        icon: (0, all_1.css) `
      padding: 0;
      width: 3.5rem;
      min-width: unset;
      @media ${all_1.mobile} {
        width: 3.5rem;
      }
    `,
        iconSecondary: (0, all_1.css) `
      ${(theme) => theme.buttons.icon};
      background-color: ${(theme) => theme.colors.gray.light};
      color: ${(theme) => theme.icon};
    `,
        ghost: (0, all_1.css) `
      background: transparent;
      border: 1px solid ${(theme) => theme.colors.primary};
      color: ${(theme) => theme.colors.primary};
    `,
        transparent: (0, all_1.css) `
      background: transparent;
    `,
    },
    typography: {
        css: (0, all_1.css) `
      font-feature-settings: 'case';
      color: #000000;
    `,
        h1: (0, all_1.css) `
      font-family: ${(theme) => theme.font};
      font-weight: 400;
      line-height: 120%;
      font-size: 3.25rem;
      @media ${all_1.notDesktop} {
        font-size: 2.25rem;
        line-height: 150%;
      }
    `,
        'sub-h1': (0, all_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
      font-weight: 300;
      line-height: 140%;
      font-size: 2.25rem;
    `,
        h2: (0, all_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
      font-weight: 300;
      line-height: 120%;
      font-size: 8.125rem;
      @media ${all_1.notDesktop} {
        font-size: 3.75rem;
        line-height: 120%;
      }
    `,
        'sub-h2': (0, all_1.css) `
      font-size: 1.25rem;
      font-weight: 300;
      line-height: 100%;
    `,
        h3: (0, all_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
      font-weight: 300;
      line-height: 120%;
      font-size: 6.875rem;
      @media ${all_1.notDesktop} {
        font-size: 3.25rem;
        line-height: 120%;
      }
    `,
        h4: (0, all_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
      font-weight: 300;
      line-height: 140%;
      font-size: 3.25rem;
      @media ${all_1.notDesktop} {
        font-size: 2rem;
        line-height: 120%;
      }
    `,
        'sub-h4': (0, all_1.css) `
      font-family: ${(theme) => theme.font};
      font-weight: 400;
      font-size: 1rem;
      line-height: 150%;
      letter-spacing: 5%;
    `,
        h5: (0, all_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
      font-weight: 300;
      line-height: 140%;
      font-size: 2.25rem;
    `,
        h6: (0, all_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
      font-weight: 300;
      line-height: 130%;
      font-size: 1.25rem;
    `,
        p: (0, all_1.css) `
      font-family: ${(theme) => theme.font};
      font-weight: 400;
      line-height: 170%;
      letter-spacing: 0.03rem;
      font-size: 1rem;
    `,
        'sub-p': (0, all_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
      font-weight: 300;
      line-height: 140%;
      font-size: 1.125rem;
    `,
        'caption-1': (0, all_1.css) `
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 150%;
      color: ${(theme) => theme.colors.additional[1]};
    `,
        li: (0, all_1.css) `
      text-align: left !important;
    `,
    },
    links: {
        css: (0, all_1.css) `
      text-decoration: underline;
    `,
    },
    inputs: {
        message: (0, all_1.css) `
      text-align: left;
      margin-bottom: ${(theme) => theme.spacing.small};
    `,
        css: (0, all_1.css) `
      color: white;
      height: 3.5rem;
      &::placeholder {
        color: white;
        font-family: ${(theme) => theme.font};
        font-weight: 500;
        font-size: 1rem;
        text-transform: uppercase;
      }
      border-radius: 0;
      border: none;
      margin-top: 0.0625rem;
      border-bottom: 1px solid white;
      font-family: ${(theme) => theme.secondaryFont};
      font-size: 1.5rem;
      padding: 0;
      margin-bottom: 1rem;
      width: 100%;
    `,
        checkbox: {
            css: (0, all_1.css) `
        --background: transparent !important;
        --active-inner: transparent !important;
        --active: white !important;
        border-radius: 0 !important;
        border-width: thin;
      `,
            label: (0, all_1.css) `
        transform: none;
        margin-left: 1rem;
        text-align: left;
      `,
        },
        textarea: {
            css: (0, all_1.css) `
        background: transparent;
        border: 1px solid white;
        padding: ${(theme) => theme.spacing.small};
        &::placeholder {
          opacity: 0.5;
          font-size: 1.125rem;
          font-weight: 300;
          line-height: 150%;
        }
      `,
            label: (0, all_1.css) `
        position: static;
        margin-bottom: ${(theme) => theme.spacing.extraSmall};
        transform: none;
        justify-content: flex-start;
        letter-spacing: 0.03rem;
        margin-top: ${(theme) => theme.spacing.large};
      `,
        },
        label: (0, all_1.css) `
      cursor: text;
      color: white;
      z-index: 1;
      font-size: 1rem;
      user-select: none;
      position: absolute;
      top: 125%;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.15rem;
      transition: 150ms all;
      font-size: 1.0625rem;
      margin: 0;
    `,
    },
    context: {
        heading: {
            page: {
                width: '75rem',
            },
        },
        sign: {
            inputs: {
                css: (0, all_1.css) `
          color: black;
        `,
                text: {
                    css: (0, all_1.css) `
            border-color: ${(theme) => theme.stroke};
          `,
                    label: (0, all_1.css) `
            color: ${(theme) => theme.stroke};
            top: 0;
          `,
                },
            },
            links: {
                css: (0, all_1.css) `
          color: black !important;
        `,
            },
            buttons: {
                ghost: (0, all_1.css) `
          border-color: ${(theme) => theme.stroke};
          color: ${(theme) => theme.stroke};
        `,
            },
        },
        checkout: {
            global: (0, all_1.css) `
        * {
          cursor: initial !important;
        }
      `,
            inputs: {
                css: (0, all_1.css) `
          height: 3.5rem;
          padding: 0 1rem;
          border: 0.0625rem solid ${(theme) => theme.stroke};
          border-radius: ${(theme) => theme.radius.small};
          ${all_1.styled.focus `
            border: 0.0625rem solid ${(theme) => theme.colors.primary};
            border-color: ${(theme) => theme.colors.primary};
            box-shadow: 0px 0px 0px 0.0625rem ${(theme) => theme.colors.primary};
          `}
        `,
                textarea: {
                    label: (0, all_1.css) `
            top: 1rem;
            bottom: unset;
          `,
                },
                label: (0, all_1.css) `
          cursor: text;
          color: ${(theme) => theme.colors.gray.semilight};
          z-index: 1;
          font-size: 1rem;
          margin-left: 0.75rem;
          user-select: none;
          position: absolute;
          top: 0.0625rem;
          bottom: 0.0625rem;
          left: ${(theme) => theme.spacing.small};
          display: flex;
          align-items: center;
          padding: 0.15rem;
          transition: 150ms all;
          font-size: 1.0625rem;
          color: ${(theme) => theme.colors.gray};
          margin: 0;
          transform: unset;
          &.focus-visible,
          &.with-value {
            top: -0.625rem;
            bottom: unset;
            left: 0.5rem;
            font-size: 0.8125rem;
            padding: 0 0.25rem;
            background-color: white;
          }
        `,
            },
            buttons: {
                css: (0, all_1.css) `
          border-radius: 0.625rem;
          height: 3.5rem;
          background: ${(theme) => theme.colors.gray};
          color: white;
          font-size: 1.0625rem;
          line-height: 150%;
        `,
            },
            typography: {
                css: (0, all_1.css) `
          font-family: 'DM Sans', sans-serif;
        `,
                h2: (0, all_1.css) `
          font-family: 'DM Sans', sans-serif;
          font-size: 1.375rem;
          font-weight: 500;
        `,
                h3: (0, all_1.css) `
          font-family: 'DM Sans', sans-serif;
          font-size: 0.9375rem;
          font-weight: 700;
          @media ${all_1.mobile} {
            font-weight: 700;
            line-height: 150% !important;
            letter-spacing: 0.1px;
            font-size: 0.9375rem;
            padding-bottom: ${(theme) => theme.spacing.extraSmall};
            white-space: nowrap;
          }
        `,
            },
        },
        cart: {
            buttons: {
                css: (0, all_1.css) `
          background: ${(theme) => theme.colors.primary};
        `,
                transparent: (0, all_1.css) `
          width: fit-content;
          height: auto;
          min-width: unset;
          padding: 0;
          font-size: 0.875rem;
          line-height: 150%;
          font-weight: 400;
          color: ${(theme) => theme.colors.additional[0]};
        `,
            },
        },
        contactModal: {
            modal: {
                css: (0, all_1.css) `
          padding: ${(theme) => theme.spacing.medium};
          > section {
            border-top: none !important;
          }
        `,
            },
            typography: {
                css: (0, all_1.css) `
          color: black;
        `,
            },
            buttons: {
                css: (0, all_1.css) `
          margin-left: auto !important;
          padding: 0 ${(theme) => theme.spacing.extraLarge};
          background: ${(theme) => theme.colors.primary};
        `,
            },
            inputs: {
                css: (0, all_1.css) `
          color: black;
        `,
                text: {
                    label: (0, all_1.css) `
            color: black;
            cursor: text;
            z-index: 1;
            font-size: 1rem;
            user-select: none;
            position: absolute;
            top: 0.0625rem;
            bottom: 0.0625rem;
            left: ${(theme) => theme.spacing.medium};
            display: flex;
            align-items: center;
            padding: 0.15rem;
            transition: 150ms all;
            font-size: 1.0625rem;
            margin: 0;
            transform: unset;
          `,
                    css: (0, all_1.css) `
            padding-left: 8rem;
            border-bottom: 1px solid black;
          `,
                },
                textarea: {
                    css: (0, all_1.css) `
            border: 1px solid black;
            padding: ${(theme) => theme.spacing.small};
          `,
                    label: (0, all_1.css) `
            color: black;
          `,
                },
            },
        },
        heroPanel: {
            typography: {
                css: (0, all_1.css) `
          color: white;
        `,
            },
            buttons: {
                css: (0, all_1.css) `
          height: 4.375rem;
        `,
            },
        },
        menuPanel: {
            background: '#000000',
            links: {
                css: (0, all_1.css) `
          text-decoration: none;
          color: #ffffff;
          :hover {
            text-decoration: none;
          }
        `,
            },
            buttons: {
                css: (0, all_1.css) `
          color: white !important;
        `,
                ghost: (0, all_1.css) `
          padding: ${(theme) => theme.spacing.small}
            ${(theme) => theme.spacing.medium};
          border: 1px solid white;
        `,
            },
            stroke: '#ffffff',
            typography: {
                css: (0, all_1.css) `
          color: white;
        `,
            },
        },
        blog: {
            page: {
                sectionSpacing: {
                    desktop: '4.5rem',
                    notDesktop: '3rem',
                },
            },
        },
        page: {
            page: {
                width: '60rem',
                sectionSpacing: {
                    desktop: '15rem',
                    notDesktop: '10rem',
                },
            },
            stroke: '#BDBDBD',
            links: {
                css: (0, all_1.css) `
          text-decoration: none;
        `,
            },
            colors: {
                primary: '#0F0F0F',
                secondary: '#FFFFFF',
                additional: ['#C4C4C4'],
            },
            inputs: {
                css: (0, all_1.css) `
          color: black;

          &::placeholder {
            color: black;
          }
        `,
                file: {
                    label: (0, all_1.css) `
            position: static;
            margin-bottom: ${(theme) => theme.spacing.extraSmall};
            transform: none;
            justify-content: flex-start;
            font-size: 1rem;
            color: #0f0f0f;
            text-transform: uppercase;
          `,
                },
                textarea: {
                    css: (0, all_1.css) `
            background: transparent;
            border: 1px solid black;
            padding: ${(theme) => theme.spacing.small};
            &::placeholder {
              opacity: 0.5;
              font-size: 1.125rem;
              font-weight: 300;
              line-height: 150%;
              font-family: ${(theme) => theme.secondaryFont};
            }
          `,
                    label: (0, all_1.css) `
            position: static;
            margin-bottom: ${(theme) => theme.spacing.extraSmall};
            transform: none;
            justify-content: flex-start;
            font-size: 1rem;
            color: #0f0f0f;
            text-transform: uppercase;
          `,
                },
                label: (0, all_1.css) `
          color: black;
          left: 0;
          top: calc(100% + 0.15rem);
          transform: none;
          color: ${(theme) => theme.colors.additional[1]};
          font-size: 0.875rem;
          font-weight: 400;
          line-height: 150%;
        `,
                checkbox: {
                    css: (0, all_1.css) `
            --background: transparent !important;
            --active-inner: transparent !important;
            --active: black !important;
            border-radius: 0 !important;
            border-width: thin;
            border-color: black;
          `,
                    label: (0, all_1.css) `
            transform: none;
            margin-left: 1rem;
            color: black;
            text-align: left !important;
          `,
                },
                text: {
                    css: (0, all_1.css) `
            border-bottom: 1px solid black;
            width: 100%;
          `,
                },
                select: {
                    css: (0, all_1.css) `
            border-bottom: none;
            border: 1px solid black;
            padding: 0 ${(theme) => theme.spacing.extraSmall};
            font-size: 1rem;
            font-weight: 500;
            text-transform: uppercase;
            min-width: 14rem;
            margin-bottom: 0;
            height: 3rem;

            ::placeholder {
              font-family: ${(theme) => theme.secondaryFont};
            }
          `,
                },
            },
            dropdown: {
                css: (0, all_1.css) `
          border-radius: 0 !important;
          padding: 0;
          border: 1px solid black !important;
          border-top: none !important;
          box-shadow: none;
        `,
                element: (0, all_1.css) `
          height: 3rem;
          padding: 0rem 0.75rem;
          color: black;
          font-family: ${(theme) => theme.secondaryFont};
          font-size: 1rem;
          font-weight: 500;
          :hover {
            background: #f0f0f0;
          }
        `,
            },
            background: '#ffffff',
            buttons: {
                css: (0, all_1.css) `
          width: auto;
          min-width: 0;
          background: #0f0f0f;
        `,
                secondary: (0, all_1.css) `
          background: ${(theme) => theme.colors.additional[2]};
        `,
                icon: (0, all_1.css) `
          color: ${(theme) => theme.colors.primary};
        `,
                transparent: (0, all_1.css) `
          color: ${(theme) => theme.colors.primary};
        `,
            },
        },
        store: {
            links: {
                css: (0, all_1.css) `
          text-decoration: none;
        `,
            },
            colors: {
                primary: '#0F0F0F',
                secondary: '#FFFFFF',
                additional: ['#C4C4C4'],
            },
            inputs: {
                css: (0, all_1.css) `
          color: black;
          margin-bottom: 0rem;

          &::placeholder {
            color: black;
          }
        `,
                checkbox: {
                    css: (0, all_1.css) `
            --background: transparent !important;
            --active-inner: transparent !important;
            --active: black !important;
            border-radius: 0 !important;
            border-width: thin;
            border-color: black;
          `,
                    label: (0, all_1.css) `
            transform: none;
            margin-left: 1rem;
            color: black;
          `,
                },
                text: {
                    css: (0, all_1.css) `
            border-bottom: 1px solid black;
            width: 100%;
          `,
                },
                select: {
                    css: (0, all_1.css) `
            border-bottom: none;
            font-family: ${(theme) => theme.font};
            font-size: 1rem;
            font-weight: 500;
            text-transform: uppercase;
            min-width: 14rem;
          `,
                    wrapper: (0, all_1.css) `
            width: auto;
          `,
                    children: (0, all_1.css) `
            > button {
              height: auto;
            }
          `,
                },
            },
            dropdown: {
                css: (0, all_1.css) `
          border-radius: 0 !important;
          padding: 0;
          border: 1px solid black;
          box-shadow: none;
        `,
                element: (0, all_1.css) `
          height: auto;
          padding: 0.35rem ${(theme) => theme.spacing.extraSmall};
          color: black;
          :hover {
            background: black;
            color: white;
          }
        `,
            },
            stroke: '#000000',
            background: '#ffffff',
            buttons: {
                css: (0, all_1.css) `
          width: auto;
          min-width: 0;
          padding: 0;
          background: red;
        `,
                icon: (0, all_1.css) `
          color: ${(theme) => theme.colors.primary};
        `,
                transparent: (0, all_1.css) `
          color: ${(theme) => theme.colors.primary};
        `,
                ghost: (0, all_1.css) `
          border-color: white;
          color: white;
        `,
            },
        },
        about: {
            page: {
                width: '51rem',
            },
        },
        footer: {
            page: {
                width: '78.625rem',
            },
            inputs: {
                text: {
                    css: (0, all_1.css) `
            border-bottom: 1px solid ${(theme) => theme.colors.secondary};
          `,
                },
                checkbox: {
                    css: (0, all_1.css) `
            --border: ${(theme) => theme.colors.secondary};
            --background: transparent !important;
            --active-inner: transparent !important;
            --active: ${(theme) => theme.colors.secondary} !important;
            border-radius: 0 !important;
            border-width: thin;
            border-color: ${(theme) => theme.colors.secondary};
          `,
                },
            },
        },
        event: {
            modal: {
                css: (0, all_1.css) `
          background: white;
          padding: ${(theme) => theme.spacing.medium};
        `,
            },
            buttons: {
                css: (0, all_1.css) `
          background: #0f0f0f;
        `,
                icon: (0, all_1.css) `
          background: transparent;
          color: #0f0f0f;
          height: auto;
          width: auto;
        `,
            },
            inputs: {
                css: (0, all_1.css) `
          color: black;
          height: 2.5rem;
          border-radius: 0;
          border: none;
          margin: 0rem;
          border-bottom: 1px solid black;
          font-family: ${(theme) => theme.secondaryFont};
          font-size: 1.5rem;
        `,
                label: (0, all_1.css) `
          color: black;
          text-transform: uppercase;
        `,
                checkbox: {
                    css: (0, all_1.css) `
            --background: transparent !important;
            --active-inner: transparent !important;
            --active: black !important;
            border-radius: 0 !important;
            border-width: thin;
            border-color: black;
          `,
                    label: (0, all_1.css) `
            transform: none;
            margin-left: 1rem;
            text-align: left;
          `,
                },
                text: {
                    label: (0, all_1.css) `
            border-bottom: 1px solid black;
          `,
                },
                textarea: {
                    css: (0, all_1.css) `
            border: 1px solid black;
            ::placeholder {
              color: black;
            }
          `,
                },
            },
        },
        withGrid: {
            page: {
                width: '84.25rem',
            },
        },
        maxPage: {
            page: {
                width: '100%',
            },
        },
        eventRegisterModal: {
            modal: {
                css: (0, all_1.css) `
          > section {
            padding: ${(theme) => theme.spacing.medium}
              ${(theme) => theme.spacing.large};
            border-top: none !important;
          }
        `,
            },
            inputs: {
                css: (0, all_1.css) `
          color: black;
        `,
                checkbox: {
                    css: (0, all_1.css) `
            position: absolute;
            top: 0.3125rem;
          `,
                    label: (0, all_1.css) `
            position: relative;
            left: 1.5rem;
            line-height: 150%;
          `,
                },
                textarea: {
                    css: (0, all_1.css) `
            border: 1px solid black;
            padding: ${(theme) => theme.spacing.small};
          `,
                    label: (0, all_1.css) `
            color: black;
          `,
                },
            },
        },
        artist: {
            links: {
                css: (0, all_1.css) `
          text-decoration: none;
        `,
            },
        },
        eventVIP: {
            modal: {
                css: (0, all_1.css) `
          background: #0f0f0f;
          color: white;

          > section {
            padding-left: ${(theme) => theme.spacing.large};
            padding-right: ${(theme) => theme.spacing.large};
            border-top: none !important;
            overflow: auto;
          }
        `,
            },
            background: '#0f0f0f',
            typography: {
                css: (0, all_1.css) `
          color: white;
        `,
            },
            links: {
                css: (0, all_1.css) `
          color: white;
        `,
            },
            buttons: {
                icon: (0, all_1.css) `
          color: white;
        `,
                ghost: (0, all_1.css) `
          border-color: white;
          color: white;
        `,
            },
            inputs: {
                css: (0, all_1.css) `
          color: white;
          height: 2.5rem;
          &::placeholder {
            opacity: 0.5;
            font-weight: 500;
            line-height: 1.5rem;
          }
          border-radius: 0;
          border: none;
          margin: 0;
          border-bottom: 1px solid white;
          font-family: ${(theme) => theme.secondaryFont};
          font-size: 1.5rem;
        `,
                text: {
                    label: (0, all_1.css) `
            border-bottom: 1px solid white;
            color: white;
          `,
                },
            },
        },
    },
});
